module.exports = __webpack_public_path__ + "static/icons/icon-resort-manager-29a614dac44beabe10b6d58171461536.svg";